module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.storeInfo.brand_name || _vm.brandInfo.name) ? _c('h1', {
    staticStyle: {
      "position": "absolute",
      "top": "-71px",
      "left": "75px",
      "font-size": "18px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.storeInfo.brand_name ? _vm.storeInfo.brand_name + ' - ' + _vm.storeInfo.name_short : _vm.brandInfo.name ? _vm.brandInfo.name : '') + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex col-sm-12 mb-3"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v(" "), _c('span', [_vm._v(" 選擇【停賣內容(名稱)】搜尋時，結果僅顯示操作停賣當下的名稱資料，若曾變更過商品、配料名稱，建議使用【停賣內容(料號)】搜尋。")]), _vm._v(" "), (this.$route.params.store_id &&
    this.$route.params.store_id !== 999999) ? _c('span', {
    staticClass: "m-l-auto"
  }, [(_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('button', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("\n                  查看批次紀錄\n                ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "dt-bootstrap"
  }, [_c('div', {
    staticClass: " row"
  }, [_c('div', {
    staticClass: "flex col-sm-6 text-light"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-group flex row h-38"
  }, [(!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "enabled": _vm.isLoading,
      "limit": _vm.startLimit,
      "option": _vm.dateoption
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'start_time')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "flex align-center p-x-5"
  }, [_vm._v("  ~  ")]), _vm._v(" "), (!_vm.isLoading) ? _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "limit": _vm.endLimit,
      "option": _vm.dateoption
    },
    on: {
      "change": function($event) {
        return _vm.queryChange($event, 'end_time')
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 m-l-5"
  }, [(_vm.storeHistory) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.action_type),
      expression: "action_type"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.action_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.queryChange($event, 'action_type')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 操作功能 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("永久停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("當日停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("多店停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("多店解除停賣")])])]) : _vm._e(), _vm._v(" "), (_vm.brandHistory) ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.queryChange($event, 'status')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("== 操作功能 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("多店解除停賣")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("多店停賣")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex col-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-10 flex row justify-content-end w-100"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSelect),
      expression: "searchSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.queryChange($event, 'search_select')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("停賣內容(名稱)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("停賣內容(料號)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("操作帳號")]), _vm._v(" "), (!this.$route.params.store_id || this.$route.params.store_id === 99999) ? _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("停賣指定門市")]) : _vm._e()])]), _vm._v(" "), (_vm.searchSelect === 1) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product_name),
      expression: "product_name"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.product_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.product_name = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'order_sn')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 2) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vendor_custom_id),
      expression: "vendor_custom_id"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.vendor_custom_id)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vendor_custom_id = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'vendor_custom_id')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 3) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'account')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(3)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.searchSelect === 4) ? _c('div', {
    staticClass: "form-group search-bar"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.store_name),
      expression: "store_name"
    }],
    staticClass: "form-control h-38",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "text"
    },
    domProps: {
      "value": (_vm.store_name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.store_name = $event.target.value
      }, function($event) {
        return _vm.queryChange($event, 'store_name')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon c-pointer",
    on: {
      "click": function($event) {
        return _vm.search(4)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center m-a-100 text-light-gray"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0 p-b-20"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作來源")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作歸屬")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作帳號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作功能")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("停賣內容")]), _vm._v(" "), (_vm.brandHistory) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("停賣指定門市")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("操作時間")])])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (!_vm.isLoading && _vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      class: {
        'bg-pre-order': order.order_method === 2
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(_vm._f("disItemSrcType")(order.src_type)) + "\n                    ")]), _vm._v(" "), (_vm.brandHistory) ? _c('td', [_vm._v("\n                      " + _vm._s(order.brand_name ? order.brand_name : '你訂') + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.storeHistory) ? _c('td', [_vm._v("\n                      " + _vm._s(order.brand_name ? order.brand_name : '你訂') + _vm._s(order.store_name ? order.store_name : '') + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(order.account) + "\n                    ")]), _vm._v(" "), (_vm.brandHistory && order.status !== undefined) ? _c('td', [_vm._v("\n                      " + _vm._s(_vm._f("disItemStatus")(order.status)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.storeHistory && order.is_batch !== undefined) ? _c('td', [(order.is_batch === 1) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("disItemStatus")(order.status)) + "\n                      ")]) : _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("disItemActionType")(order.action_type)) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.brandHistory && order.item_list) ? _c('td', [(order.item_list.package) ? _c('ul', {
      staticClass: "list-style-none p-0"
    }, [_c('li', {
      staticClass: "text-color-blue"
    }, [_vm._v("套餐")]), _vm._v(" "), _vm._l((order.item_list.package), function(value, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (order.item_list.product) ? _c('ul', {
      staticClass: "list-style-none p-0"
    }, [_c('li', {
      staticClass: "text-color-blue"
    }, [_vm._v("商品")]), _vm._v(" "), _vm._l((order.item_list.product), function(value, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (order.item_list.option) ? _c('ul', {
      staticClass: "list-style-none p-0"
    }, [_c('li', {
      staticClass: "text-color-blue"
    }, [_vm._v("配料")]), _vm._v(" "), _vm._l((order.item_list.option), function(value, key) {
      return _c('li', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.storeHistory && order.item_list) ? _c('td', [(
      order.item_list.disable &&
      order.item_list.disable.product &&
      Object.keys(order.item_list.disable.product).length ||
      order.item_list.disable &&
      order.item_list.disable.package &&
      Object.keys(order.item_list.disable.package).length ||
      order.item_list.disable &&
      order.item_list.disable.option &&
      Object.keys(order.item_list.disable.option).length ||
      order.item_list.disable &&
      order.item_list.disable.category &&
      Object.keys(order.item_list.disable.category).length ||
      order.item_list.disable &&
      order.item_list.disable.adjust &&
      Object.keys(order.item_list.disable.adjust).length
    ) ? _c('span', {
      staticClass: "spanst-style-none text-color-blue"
    }, [_vm._v("\n                        新增\n                      ")]) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.package &&
      Object.keys(order.item_list.disable.package).length
    ) ? _c('ul', [_c('li', [_vm._v("套餐")]), _vm._v(" "), _vm._l((order.item_list.disable.package), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.product &&
      Object.keys(order.item_list.disable.product).length
    ) ? _c('ul', [_c('li', [_vm._v("商品")]), _vm._v(" "), _vm._l((order.item_list.disable.product), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.option &&
      Object.keys(order.item_list.disable.option).length
    ) ? _c('ul', [_c('li', [_vm._v("配料")]), _vm._v(" "), _vm._l((order.item_list.disable.option), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.category &&
      Object.keys(order.item_list.disable.category).length
    ) ? _c('ul', [_c('li', [_vm._v("商品分類")]), _vm._v(" "), _vm._l((order.item_list.disable.category), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.disable &&
      order.item_list.disable.adjust &&
      Object.keys(order.item_list.disable.adjust).length
    ) ? _c('ul', [_c('li', [_vm._v("配料群組")]), _vm._v(" "), _vm._l((order.item_list.disable.adjust), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.product &&
      Object.keys(order.item_list.enable.product).length ||
      order.item_list.enable &&
      order.item_list.enable.package &&
      Object.keys(order.item_list.enable.package).length ||
      order.item_list.enable &&
      order.item_list.enable.option &&
      Object.keys(order.item_list.enable.option).length ||
      order.item_list.enable &&
      order.item_list.enable.category &&
      Object.keys(order.item_list.enable.category).length ||
      order.item_list.enable &&
      order.item_list.enable.adjust &&
      Object.keys(order.item_list.enable.adjust).length
    ) ? _c('span', {
      staticClass: "spanst-style-none text-color-blue"
    }, [_vm._v("\n                        解除\n                      ")]) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.package &&
      Object.keys(order.item_list.enable.package).length
    ) ? _c('ul', [_c('li', [_vm._v("套餐")]), _vm._v(" "), _vm._l((order.item_list.enable.package), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.product &&
      Object.keys(order.item_list.enable.product).length
    ) ? _c('ul', [_c('li', [_vm._v("商品")]), _vm._v(" "), _vm._l((order.item_list.enable.product), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.option &&
      Object.keys(order.item_list.enable.option).length
    ) ? _c('ul', [_c('li', [_vm._v("配料")]), _vm._v(" "), _vm._l((order.item_list.enable.option), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.category &&
      Object.keys(order.item_list.enable.category).length
    ) ? _c('ul', [_c('li', [_vm._v("商品分類")]), _vm._v(" "), _vm._l((order.item_list.enable.category), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e(), _vm._v(" "), (
      order.item_list.enable &&
      order.item_list.enable.adjust &&
      Object.keys(order.item_list.enable.adjust).length
    ) ? _c('ul', [_c('li', [_vm._v("配料群組")]), _vm._v(" "), _vm._l((order.item_list.enable.adjust), function(value, key) {
      return _c('li', {
        key: key,
        staticClass: "list-style-none"
      }, [_vm._v("\n                          " + _vm._s(key) + " - " + _vm._s(value) + "\n                        ")])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.brandHistory && order.store_list) ? _c('td', _vm._l((order.store_list), function(value, key, index) {
      return _c('span', {
        key: key
      }, [_vm._v("\n                          " + _vm._s(value) + "\n                          "), (index < Object.keys(order.store_list).length - 1) ? _c('span', [_vm._v("、")]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTime(order.created_time) || _vm.getTime(order.create_time)))])])
  }), 0) : (!_vm.isLoading && _vm.orderList.length === 0) ? _c('tbody', [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), (!_vm.orderList.length && _vm.$route.name === 'onSiteOrderTableInfo') ? _c('div', {
    staticClass: "text-center m-a-100 text-light-gray"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "m-t-5"
  }, [_vm._v("沒有符合的資料")])]) : _vm._e()]), _vm._v(" "), _c('paginate', {
    attrs: {
      "clickPage": _vm.paginateClickPage,
      "groupAmount": _vm.paginate.groupAmount,
      "isActive": _vm.paginateIsActive,
      "pageAmount": _vm.paginateAmount,
      "total": _vm.paginate.total
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-size-80"
  }, [_c('i', {
    staticClass: "ion ion-clipboard"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d105827"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/DisItemTableHistoryTemp.vue
// module id = 2412
// module chunks = 1